import { Injectable } from '@angular/core';
import { IAppConfig } from 'src/app/app-config.model';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  static settings: IAppConfig;
    constructor(private http: HttpClient) {}
    load() {
        const jsonFile = `configs/config.json`;
        return new Promise<void>((resolve, reject) => {
            this.http.get<IAppConfig>(jsonFile).toPromise().then((response : IAppConfig) => {
              ConfigService.settings = <IAppConfig>response;
               resolve();
            }).catch((response: any) => {
               console.log(`Could not load file '${jsonFile}': ${JSON.stringify(response)}`);
               resolve(this.loadNgServeConfig());
            });
        });
    }

    loadNgServeConfig(){
      //Nel caso in cui sto servendo l'applicazione con ng serve anziché nginx
      console.log(`Prendo la configurazione di default dell'environment ${environment.name}`);
      const jsonFile = `configs/config.${environment.name}.json`;
      console.log(jsonFile);
        return new Promise<void>((resolve, reject) => {
            this.http.get<IAppConfig>(jsonFile).toPromise().then((response : IAppConfig) => {
              ConfigService.settings = <IAppConfig>response;
               resolve();
            }).catch((response: any) => {
               reject(`Could not load file '${jsonFile}': ${JSON.stringify(response)}`);
            });
        });
    }
}
